declare global {
  interface Window {
    __OTW_ENABLE_PRICING_COMPARE_WORKSPACE__?: boolean
  }
}

const runtimeFlag =
  typeof window !== 'undefined' ? window.__OTW_ENABLE_PRICING_COMPARE_WORKSPACE__ : undefined

export const isPricingCompareWorkspaceEnabled = runtimeFlag ?? true
